import { palette } from '@guardian/source/foundations';
export const themeButtonLegacyGray = {
    textPrimary: palette.neutral[100],
    backgroundPrimary: palette.neutral[20],
    textTertiary: palette.neutral[20],
    backgroundTertiary: 'transparent',
    borderTertiary: palette.neutral[20],
};
